__turbopack_context__.v({
  "arrowBtn": "SliderFullwidthGallery-module-scss-module__2pO2Ra__arrowBtn",
  "arrowDisabled": "SliderFullwidthGallery-module-scss-module__2pO2Ra__arrowDisabled",
  "arrows": "SliderFullwidthGallery-module-scss-module__2pO2Ra__arrows",
  "controls": "SliderFullwidthGallery-module-scss-module__2pO2Ra__controls",
  "entryEffect": "SliderFullwidthGallery-module-scss-module__2pO2Ra__entryEffect",
  "galleryItem": "SliderFullwidthGallery-module-scss-module__2pO2Ra__galleryItem",
  "scrollbar": "SliderFullwidthGallery-module-scss-module__2pO2Ra__scrollbar",
  "slide": "SliderFullwidthGallery-module-scss-module__2pO2Ra__slide",
  "slideFill": "SliderFullwidthGallery-module-scss-module__2pO2Ra__slideFill",
  "swiper": "SliderFullwidthGallery-module-scss-module__2pO2Ra__swiper",
  "visible": "SliderFullwidthGallery-module-scss-module__2pO2Ra__visible",
  "wrapper": "SliderFullwidthGallery-module-scss-module__2pO2Ra__wrapper",
});
